import api from './Api'

const route = '/report'

export default {
  getReport1: (params = {}) => api().get(`${route}/report1`, { params: { ...params, format: 'json' } }),
  downloadReport1: (params = {}) => api().get(`${route}/report1`, {
    params: { ...params, format: 'excel' },
    responseType: 'blob'
  }),

  getReport2: (params = {}) => api().get(`${route}/report2`, { params: { ...params, format: 'json' } }),
  downloadReport2: (params = {}) => api().get(`${route}/report2`, {
    params: { ...params, format: 'excel' },
    responseType: 'blob'
  }),

  getReport3: (params = {}) => api().get(`${route}/report3`, { params: { ...params, format: 'json' } }),
  downloadReport3: (params = {}) => api().get(`${route}/report3`, {
    params: { ...params, format: 'excel' },
    responseType: 'blob'
  }),

  getReport4: (params = {}) => api().get(`${route}/report4`, { params: { ...params, format: 'json' } }),
  downloadReport4: (params = {}) => api().get(`${route}/report4`, {
    params: { ...params, format: 'excel' },
    responseType: 'blob'
  }),

  getReport5: (params = {}) => api().get(`${route}/report5`, { params: { ...params, format: 'json' } }),
  downloadReport5: (params = {}) => api().get(`${route}/report5`, {
    params: { ...params, format: 'excel' },
    responseType: 'blob'
  }),

  getReport6: (params = {}) => api().get(`${route}/report6`, { params: { ...params, format: 'json' } }),
  downloadReport6: (params = {}) => api().get(`${route}/report6`, {
    params: { ...params, format: 'excel' },
    responseType: 'blob'
  }),

  // Opciones de los filtros: { dealers, responsibles, creators } (period, start_date, end_date y dealer_id opcionales)
  getReportFilters: (params = {}) => api().get(`${route}/report-filters`, { params }),

  // PDF de cualquiera de los 6 reports (mismos filtros que el Excel)
  downloadReportPdf: (number, params = {}) => api().get(`${route}/report${number}`, {
    params: { ...params, format: 'pdf' },
    responseType: 'blob',
    // Api.js fija Accept: application/json; para el PDF se pide cualquier tipo (igual que el comodato)
    headers: { Accept: 'application/pdf, */*' }
  })
}
